import { configs } from '@hero/configs';
import { useIsAutomationEnabled } from '@hero/hooks';
import { ROUTE_PATHS } from '@hero/routes';

import { SIDEBAR_STATUS } from './constants';

function useSidebarItems() {
  const isAutomationEnabled = useIsAutomationEnabled();

  return [
    {
      value: 'home',
      icon: 'home',
      label: 'homepage',
      link: ROUTE_PATHS?.HOME,
      status: !configs.homePage?.enabled && SIDEBAR_STATUS.disabled
    },
    {
      value: 'dashboard',
      icon: 'dashboard',
      label: 'dashboard',
      link: ROUTE_PATHS?.DASHBOARD
    },
    {
      value: 'giftCampaigns',
      icon: 'gift-box',
      label: 'giftCampaigns',
      link: ROUTE_PATHS?.MY_RECOGNITIONS
    },
    {
      value: 'recurringGifts',
      icon: 'automation',
      label: 'recurringGifts',
      link: ROUTE_PATHS?.MY_AUTOMATION_LIST,
      status: !isAutomationEnabled && SIDEBAR_STATUS.disabled
    },
    {
      value: 'collections',
      icon: 'collections',
      label: 'collections',
      link: ROUTE_PATHS?.COLLECTIONS()
    },
    {
      value: 'contacts',
      icon: 'contacts',
      label: 'contacts',
      link: ROUTE_PATHS?.CONTACTS
    }
  ];
}

export { useSidebarItems };
